import createReducer from 'utils/redux/createReducer'

const initialState = {
	content: ''
  , files: []
}

export default createReducer(initialState, {
	CHANGED_CONTENT: (currentState, action) => ({
		...currentState
	  , content : action.data
	})
  , ADDED_ATTACHMENT: (currentState, action) => ({
		...currentState
	  , files: [
			...currentState.files
		  , action.data
		]
	})
  , DELETE_ATTACHMENT_NEW_COMMENT: (currentState, action) => ({
		...currentState
	  , files: [
			...currentState.files.slice(0, action.data)
		  , ...currentState.files.slice(action.data + 1)
		]
	})
  , RESET_FORM: currentState => ({
  	content: ''
    , files: []
  })
})



// WEBPACK FOOTER //
// ./src/reducers/newComment.js